import { GlobalService } from '../../services/global.service';
import { AdminPresenceService } from '../../services/admin.presence.service'; // /services/admin.presence.service
import { Subscription } from 'rxjs';
import { Component, OnDestroy, OnInit } from '@angular/core';

import { SelectItem } from 'primeng/primeng';

import { TicketService } from '../../services/ticket.service';
import { CustomTicketWidgetItemArray } from '../../models/domain/custom.ticket.widget';
import { IBaseResponse } from '../../models/comm-http/responses/BaseResponse';
import { ssApiService } from '../../services/ss-api.service';
import { CustomTicketItemArray, TicketStatusTypes } from '../../models/domain/custom.ticket.item';
import { CustomTicketsWidgetsSearchRequest } from '../../models/ss-api/requests/custom.tickets.widgets.search.request';

export class AdminTicketItem {
    AdminID: number;
    Name: string;
    Tickets: CustomTicketWidgetItemArray;
}

@Component({
    selector: 'ticket-dashboard',
    templateUrl: './ticket.dashboard.component.html',
    styleUrls: ['./ticket.dashboard.component.css']
})

export class TicketDashboardComponent implements OnInit, OnDestroy {


    IsBusy: boolean = false;
    AssignedIsBusy: boolean = false;

    draggedTicket: boolean;

    ReloadTicketsSubscription: Subscription;
    liveTicketAssignedtoAdmin: Subscription;

    public UnclaimedTickets: CustomTicketItemArray = new CustomTicketItemArray();

    UnclaimedTicketsCount: number;

    TicketFilter: string;

    public AssignedTickets: Array<AdminTicketItem> = new Array<AdminTicketItem>();

    // List View Options
    unclaimedIsListView: boolean = false;
    isListView: boolean = false;

    //Closed filters
    UnclaimedIncludeClosed: boolean = false;
    UnclaimedEverIncludeClosed: boolean = false;

    // SEARCH OPTIONS
    StartDate: Date = new Date();
    EndDate: Date = new Date();

    DateSearchOptions: SelectItem[];
    SelectedDateSearchOption: number = 1;

    constructor(
        private presence: AdminPresenceService,
        public api: ssApiService,
        private gb: GlobalService,
        private ticketService: TicketService
    ) { }

    ngOnInit() {
        this.gb.SetPageTitle('Ticket Dashboard');
        // this.liveTicketAssignedtoAdmin = this.live.onTicketAssignedToAdmin.subscribe(
        // 	(data) => {
        // 		var user = this.presence.AdminPresences.find(x => x.AdminID == data.AdminID);
        // 		if (user.AdminID != this.gb.AdminId)
        // 			xToastr.ShowToast(ToastrTypes.Warning, "Ticket Claimed", this.presence.GetFullName(user) + " just claimed ticket: " + data.TicketNR);
        // 	}
        // );

        this.DateSearchOptions = [
            { label: 'Search by Creation Date', value: 0 },
            { label: 'Search by Due Date', value: 1 }
        ];

        this.ReloadTicketsSubscription = this.api.onCustomTicketsReload.subscribe(x => {
            this.LoadAdminTickets();
            this.LoadUnclaimedTickets();
        });

        this.StartDate.setTime(this.StartDate.getTime() - (24 * 60 * 60 * 1000) * 30); // subtract 30 days
        this.EndDate.setTime(this.EndDate.getTime());

        this.IsBusy = true;
        this.LoadUnclaimedTickets();
        this.LoadAdminTickets();
        this.SetListViewStyles();
        this.IsBusy = false;

    }

    UnclaimedClosedFilterChanged(newState: boolean){
        this.UnclaimedIncludeClosed = newState;
        if (this.UnclaimedIncludeClosed && !this.UnclaimedEverIncludeClosed){
            //we're including closed tickets for the first time.  Reload
            this.UnclaimedEverIncludeClosed = true;
            this.LoadUnclaimedTickets();
        }
    }


    LoadUnclaimedTickets() {
        this.IsBusy = true;
        let subscription = this.api.GetCustomTicketsUnclaimed(this.UnclaimedIncludeClosed).subscribe(
            (result: IBaseResponse<CustomTicketItemArray>) => {
                subscription.unsubscribe();
                if (!result.Result) {
                    this.IsBusy = false;
                    return;
                }

                this.UnclaimedTickets = result.Data.sort((left, right) => {
                    if (new Date(left.DueDate) >= new Date(right.DueDate)) {
                        return 1;
                    } else {
                        return -1;
                    }
                });
                // this.Totals = result.Data.Totals;
                // this.UnclaimedTicketsCount = result.Data.NotAssigned;

                this.IsBusy = false;
            }, (error: any) => {
                subscription.unsubscribe();
                this.IsBusy = false;
            }
        );

    }

    ExampleLoad() {
        // for admin 1 all statuses except closed
        // var request = CustomTicketsWidgetsSearchRequest.GetBaseStausSearchForAdmin(1);

        // for admin 1 closed and new
        let request1 = CustomTicketsWidgetsSearchRequest.GetBaseSearchForAdmin(1)
        request1.Status = new Array<TicketStatusTypes>(TicketStatusTypes.Closed, TicketStatusTypes.New)


        // for admin 1 closed
        let request = CustomTicketsWidgetsSearchRequest.GetEmptySearch();
        request.Status = new Array<TicketStatusTypes>(TicketStatusTypes.New,
            TicketStatusTypes.InProgress,
            TicketStatusTypes.AwaitingAdminResponse,
            TicketStatusTypes.AwaitingMemberResponse,
            TicketStatusTypes.TOS,
            TicketStatusTypes.UpgradePaymentDeclined,
            TicketStatusTypes.UpgradeOK,
            TicketStatusTypes.Closed);

        // this.api.getEmp
        let subscription = this.api.CustomTicketsSeachWidgets(request).subscribe(
            response => {
                subscription.unsubscribe();
                console.log(response)
            }
        )
    }

    async LoadAdminTickets() {
        this.IsBusy = true;
        this.AssignedTickets = new Array<AdminTicketItem>();

        let newTicketsArray: CustomTicketWidgetItemArray = [];

        // for admin 1 closed
        let request = CustomTicketsWidgetsSearchRequest.GetEmptySearch();
        request.Status = new Array<TicketStatusTypes>(TicketStatusTypes.New,
            TicketStatusTypes.InProgress,
            TicketStatusTypes.AwaitingAdminResponse,
            TicketStatusTypes.AwaitingMemberResponse,
            TicketStatusTypes.TOS,
            TicketStatusTypes.UpgradePaymentDeclined,
            TicketStatusTypes.UpgradeOK);

        if (this.SelectedDateSearchOption == 0) {
            request.StartDateTimeCreated = this.StartDate;
            request.EndDateTimeCreated = this.EndDate;
        } else {
            request.StartDueDate = this.StartDate;
            request.EndDueDate = this.EndDate;
        }

        await this.api.CustomTicketsSeachWidgets(request).toPromise().then(
            response => {
                newTicketsArray = response.Data;
                console.log('newTicketsArray : ', newTicketsArray);
                this.IsBusy = false;
            }
        ).catch(error => { console.log('ERROR', error) });

        await this.gb.GetAdmins().then(y => y.forEach(async x => {
            if (x.FirstName == 'API')
                return;

            let newItem: AdminTicketItem = new AdminTicketItem;
            newItem.AdminID = x.AdminID;
            newItem.Name = x.FirstName + ' ' + x.LastName;
            newItem.Tickets = [];
            newTicketsArray.forEach(t => {
                if (t.AdminID == x.AdminID)
                    newItem.Tickets.push(t);

            });
            console.log('Got a new Admin', newItem);
            this.AssignedTickets.push(newItem);

        }));

        this.SortAssigned();

    }

    SortAssigned() {

        this.AssignedIsBusy = true;

        setTimeout(() => {
            this.AssignedTickets.sort((a, b) => a.Name.localeCompare(b.Name));
            this.AssignedIsBusy = false;

        }, 500);

    }

    ngOnDestroy() {

        if (this.liveTicketAssignedtoAdmin != undefined)
            this.liveTicketAssignedtoAdmin.unsubscribe();

        if (this.ReloadTicketsSubscription != undefined)
            this.ReloadTicketsSubscription.unsubscribe();
    }

    public ticketDropped(e: any): void {
        this.draggedTicket = false;
    }

    dragEnter() {
        this.draggedTicket = true;
    }

    dragExit() {
        this.draggedTicket = false;
    }

    SetUnclaimedTicketListStyle(newIsListView: boolean) {
        localStorage.setItem('crm_UnclaimedTicketsListView', JSON.stringify(newIsListView));
    }

    SetAssignedTicketListStyle(newIsListView: boolean) {
        this.isListView = newIsListView;
        localStorage.setItem('crm_AssignedTicketsListView', JSON.stringify(this.isListView));
    }

    SetListViewStyles() {
        this.unclaimedIsListView = JSON.parse(localStorage.getItem('crm_UnclaimedTicketsListView'));
        this.isListView = JSON.parse(localStorage.getItem('crm_AssignedTicketsListView'));
    }

    TitleForAssignedTickets(item: AdminTicketItem): string {
        let title = '';
        let pastDueTickets = item.Tickets.filter(item => {
            if (item.Status == 99) { return false };
            return new Date(item.DueDate).setHours(0, 0, 0, 0) < new Date().setHours(0, 0, 0, 0);
        })

        let dueTickets = item.Tickets.filter(item => {
            if (item.Status == 99) { return false };
            return new Date(item.DueDate).setHours(0, 0, 0, 0) >= new Date().setHours(0, 0, 0, 0);
        })

        title += item.Name;

        if (pastDueTickets.length > 0) {
            title += ' ( Due: ' + dueTickets.length + ' | Past Due: ' + pastDueTickets.length + ' )';
        }

        return title;
    }

}
